/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Konsultan_A2tInputs */

const en_mk_sol_konsultan_a2t = /** @type {(inputs: Mk_Sol_Konsultan_A2tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Research agent`)
};

const id_mk_sol_konsultan_a2t = /** @type {(inputs: Mk_Sol_Konsultan_A2tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen Riset`)
};

/**
* | output |
* | --- |
* | "The Research agent" |
*
* @param {Mk_Sol_Konsultan_A2tInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_konsultan_a2t = /** @type {((inputs?: Mk_Sol_Konsultan_A2tInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Konsultan_A2tInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_konsultan_a2t(inputs)
	return en_mk_sol_konsultan_a2t(inputs)
});